import { createSlice } from "@reduxjs/toolkit";
import { readStoredString } from "../storage";

const initialState = {
    themeColor: readStoredString("themeColor"),
};
export const userSlice = createSlice({
  name: "themes",
  initialState,
  reducers: {
    themeColor: (state, payload) => {
      state.themeColor = payload.payload;
      localStorage.setItem("themeColor", JSON.stringify(payload.payload));
    },
  },
});

export default userSlice.reducer;
export const { themeColor } = userSlice.actions;
